module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Weinfelden-bfd60efbc56a859390ab10cc5719385a.png";